export default "__VITE_ASSET__Csi3oscR__"